import { motion, useReducedMotion } from "framer-motion";

// Subtle, professional scroll reveal. Gentle upward slide once in view.
// Transform-only (no opacity gate) so content is always legible even if the
// animation timeline stalls or JS is slow — respects reduced-motion.
export const Reveal = ({ children, delay = 0, className = "", y = 22, as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  const reduce = useReducedMotion();
  if (reduce) return <MotionTag className={className}>{children}</MotionTag>;
  return (
    <MotionTag
      className={className}
      initial={{ y }}
      whileInView={{ y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
};

export const StaggerGroup = ({ children, className = "" }) => {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-50px" }}
      variants={{ hidden: {}, show: { transition: { staggerChildren: 0.07 } } }}
    >
      {children}
    </motion.div>
  );
};

export const StaggerItem = ({ children, className = "", id }) => {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className} id={id}>{children}</div>;
  return (
    <motion.div
      id={id}
      className={className}
      variants={{
        hidden: { y: 20 },
        show: { y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
      }}
    >
      {children}
    </motion.div>
  );
};
